import React, { useEffect, useState } from "react";
import NavBarDark from "../components/NAVBAR/NavBarDark";
import Footer from "../components/FOOTER/Footer";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import Modal from "react-modal";
import { X } from "phosphor-react";
import { fetch_event, get_event_rsvp, update_event_rsvp } from "../api/event";
import moment from 'moment';
import GuestList from "../components/GuestList";
import AuthRSVPManager from "../components/RSVP/AuthRSVPManager";
import { getWithExpiry } from "../utils/storage";
import { Calendar, MapPin } from "phosphor-react";
import { toast } from "react-toastify";

export default function RSVPDetailsPage() {
  const [guest, setGuest] = useState(null)
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [displayType, setDisplayType] = useState("approve")  
  const [inputValues, setInputValues] = useState({
    class: "",
  });
  const [err, setErr] = useState({    

    class: "",
    email: "",
  });

  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }


  const location = useLocation();
  const event_id = getQueryParam('event_id', location.search);
  const guestData = location.state;

  useEffect(() => {
    setUp()
  }, [])

  const setUp = () => {
    setGuest(guestData)
  }

  const customStyles = {
    content: {
      // top: '50%',
      // left: '50%',
      // right: 'auto',
      // bottom: 'auto',
      // marginRight: '-50%',
      zIndex: 99999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      backdropFilter: "blur(2px)",
    },
  };

  const toggleModal = (value) => {
    setModalIsOpen(value);
  };

  const handleInputChange = (event) => {
    const target = event.target;

    const value =
      target.type === "checkbox" || target.type === "radio"
        ? target.checked
        : target.value;
    const name = target.name;

    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const updateRSVP = async (status) => {
    try {
      setIsSubmitting(true);
      toggleModal(false)

      const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + event_id);

      var params = {
        event_id: event_id ?? '',
        session_key: rsvpManagerSession,
        invitation_type: inputValues.class,
        rsvp_id: guest.rsvp_id,
        status,
      }

      console.log('params', params);

      const res = await update_event_rsvp(params)
      const response = await res.json()
      console.log('res', res.status);
      console.log('response', response);
      setIsSubmitting(false);
      if (res.ok) {
        setGuest(prev => ({
          ...prev,
          status,
          invitation_type: status === 'Approved' ? inputValues.class : 'Regular',
        }))
        toast.success(response?.message ?? `RSVP ${status}` , {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      } else {
        toast.error(response.message, {
          position: "top-right",
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        
      }

    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  return (
    <div>
      <Helmet>
        <title>
          RSVP Details - Venco Events | All-in-one Community Management
          Software
        </title>
        <meta
          property="og:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
        <meta
          name="twitter:title"
          content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
        />
      </Helmet>
      <NavBarDark />
      <section className="container mx-auto my-8 xl:py-[100px] p-4 content-center align-center  justify-center justify-items-center">
      
        <h2 className="text-2xl font-semibold mb-6 text-center">Guest Information</h2>
        
        <div 
          className=" w-full sm:w-[50%] bg-card rounded-lg border border-border px-8 py-4 self-center"
        >
          <div 
            className="flex flex-col sm:flex-row justify-between"
          >
            <div className="my-[12px]">
              <label className="text-[12px] text-gray-600 block mb-1">Full Name</label>
              <p className="text-[14px]font-medium">{guest?.guest_name}</p>
            </div>
            <div className="my-[12px]">
              <label className="text-[12px] text-gray-600 block mb-1 sm:text-right">Status</label>
              <p className="text-[14px]font-medium sm:text-right">{guest?.status}</p>
            </div>
          </div>
          <div 
            className="flex flex-col sm:flex-row justify-between"
          >
            <div className="my-[12px]">
              <label className="text-[12px] text-gray-600 block mb-1">Email Address</label>
              <p className="text-[14px]font-medium">{guest?.email}</p>
            </div>

            <div className="my-[12px]">
              <label className="text-[12px] text-gray-600 block mb-1 sm:text-right">Phone Number</label>
              <p className="text-[14px]font-medium sm:text-right">{guest?.phone_number}</p>
            </div>
          </div>
          <div 
            className="flex flex-col sm:flex-row justify-between"
          >
            {
              Boolean(guest?.invitation_type?.length) && (
                <div className="my-[12px]">
                  <label className="text-[12px] text-gray-600 block mb-1">Class</label>
                  <p className="text-[14px]font-medium">{guest?.invitation_type}</p>
                </div>
              )
            }
            
            {
              Boolean(guest?.access_code?.length) && (
                <div className="my-[12px]">
                  <label className="text-[12px] text-gray-600 block mb-1 sm:text-right">Access Code</label>
                  <p className="text-[14px]font-medium sm:text-right">{guest?.access_code}</p>
                </div>
              )
            }
            
          </div>
          
        </div>

        {/* Action Buttons */}
        {
          guest?.status === 'Pending' && (
            <div className="flex gap-4 mt-12">          
              <button 
                className="font-sora font-semibold px-8 py-3 bg-orange-300 hover:bg-orange-400 text-orange-900 rounded-full transition-colors"
                onClick={() => {
                  setDisplayType('decline')
                  setModalIsOpen(true)
                }}
              >
                Decline
              </button>
              <button 
                className="font-sora font-semibold px-8 py-3 bg-light-green-500 hover:bg-light-green-600 text-new-black-1000 rounded-full  transition-colors"
                onClick={() => {
                  setDisplayType('approve')
                  setModalIsOpen(true)
                }}
              >
                Approve
              </button>
            </div>
          )
        }

        {
          guest?.status === 'Approved' && (
            <div
              className="flex flex-col mt-12 content-center align-center  justify-center justify-items-center"
            >
              <button 
                className="font-sora font-semibold px-24 py-3 bg-light-green-500 hover:bg-light-green-600 text-new-black-1000 rounded-full  transition-colors"
                onClick={() => {
                  // setDisplayType('cancel')
                  // setModalIsOpen(true)
                }}
              >
                Confirm Arrival
              </button>
              <div
                className="mt-[20px] content-center align-center  justify-center justify-items-center"
                onClick={() => {
                  setDisplayType('cancel')
                  setModalIsOpen(true)
                }}
              >
                <p
                  className="font-sora font-semibold text-red-700 underline text-[14px] cursor-pointer"
                >
                  Cancel RSVP
                </p>
              </div>
            </div>
          )
        }

        {
          (guest?.status === 'Cancelled' || guest?.status === 'Declined') && (
            <div
              className="flex flex-col mt-12 content-center align-center  justify-center justify-items-center"
            >
              <button 
                className="font-sora font-semibold px-24 py-3 bg-light-green-500 hover:bg-light-green-600 text-new-black-1000 rounded-full  transition-colors"
                onClick={() => {
                  setDisplayType('approve')
                  setModalIsOpen(true)
                }}
              >
                Re-Approve
              </button>
            </div>
          )
        }
        

      </section>

      <Footer  />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => toggleModal(false)}
        style={customStyles}
        // contentLabel="Vessel Modal"
        // overlayClassName="modal-overlay"
        className="vessel-modal"
      >
        {
          displayType === 'approve' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Guest Invitation Class
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3">
                Invitation Class
              </p>

              <select
                name="class"
                id="class"
                // className="input-field"
                className={`formInput mt-5 ${Boolean(err.class.length) ? "border-red-500" : ""
                  }`}
                value={inputValues.class}
                onChange={handleInputChange}
                required
              >
                <option value="" defaultValue disabled>
                  Select Class
                </option>
                <option value="Regular" key="Regular">
                  Regular
                </option>
                <option value="VIP" key="VIP">
                  VIP
                </option>
                <option value="VVIP" key="VVIP">
                  VVIP
                </option>
                <option value="VVVIP" key="VVVIP">
                  VVVIP
                </option>
              </select>

              {Boolean(err.class.length) ? (
                <p className="input-field-err-msg">{err.class}</p>
              ) : null}

              <button
                className="primaryButton w-full mt-[30px]"
                onClick={() => {
                  updateRSVP('Approved')
                }}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          )
        }
        
        {
          displayType === 'decline' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Please Confirm
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3">
                Are you sure you want to decline this RSVP request?
              </p>

              <button
                className="secondaryButton w-full mt-[30px]"
                onClick={() => {
                  setModalIsOpen(false)
                }}
              >
                No, take me back
              </button>
              <button
                className="primaryButton w-full mt-[15px]"
                onClick={() => {
                  updateRSVP('Declined')
                }}
              >
                Yes, I want to
              </button>
            </div>
          )
        }
        {
          displayType === 'cancel' && (
            <div className="mt-[250px] bg-white rounded-xl p-5 m-4 w-[320px] sm:w-[460px] lg:p-[30px]">
              <div className="flex justify-end pb-2">
                <div className="" onClick={() => toggleModal(false)}>
                  <X weight="bold" className="text-base font-semibold" />
                </div>
              </div>
              <p 
                className="font-sora text-new-black-500 text-lg font-medium"
              >
                Please Confirm
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-3 ">
                Are you sure you want to CANCEL this RSVP request?
              </p>

              <button
                className="secondaryButton w-full mt-[30px]"
                onClick={() => {
                  setModalIsOpen(false)
                }}
              >
                No, take me back
              </button>
              <button
                className="primaryButton w-full mt-[15px]"
                onClick={() => {
                  updateRSVP('Cancelled')
                }}
              >
                Yes, I want to
              </button>
            </div>
          )
        }
        
      </Modal>
    </div>
  )
}
